"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$toc = exports.$tocSupplProvision = exports.$tocArticle = exports.$tocArticleGroup = exports.$tocPreambleLabel = exports.tocToLines = exports.tocItemToLines = void 0;
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_1 = require("../../../util");
const util_2 = require("../util");
const factory_1 = __importDefault(require("../factory"));
const inline_1 = require("../../../node/cst/inline");
const _sentenceChildren_1 = require("../../cst/rules/$sentenceChildren");
const util_3 = require("../../cst/util");
const virtualLine_1 = require("../virtualLine");
const controls_1 = require("../../../node/el/controls");
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const el_1 = require("../../../node/el");
const num_1 = require("../../../law/num");
/**
 * The renderer for {@link std.TOC}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$toc.spec.ts) for examples.
 */
const tocItemToLines = (el, indentTexts) => {
    const lines = [];
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    if ((0, std_1.isTOCPreambleLabel)(el) || (0, std_1.isTOCAppdxTableLabel)(el)) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, el.children)])
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else if ((0, std_1.isTOCArticleGroup)(el)) {
        const mainTag = std.articleGroupTags[std.tocArticleGroupTags.indexOf(el.tag)];
        const articleGroupTitle = el.children.find(std.isArticleGroupTitle);
        const articleRange = el.children.find(std.isArticleRange);
        const sentenceChildren = (0, util_3.mergeAdjacentTextsWithString)([
            ...(articleGroupTitle?.children ?? []),
            ...(/^[(（]/.exec(articleRange?.text() ?? "（")
                ? []
                : [toCSTSettings_1.default.MARGIN]),
            ...(articleRange?.children ?? []),
        ]);
        lines.push(new line_1.ArticleGroupHeadLine({
            range: null,
            indentTexts,
            mainTag,
            controls: [],
            sentenceChildren,
            lineEndText: toCSTSettings_1.default.EOL,
        }));
        for (const child of el.children) {
            if (std.isArticleGroupTitle(child) || std.isArticleRange(child)) {
                continue;
            }
            lines.push(...(0, exports.tocItemToLines)(child, childrenIndentTexts));
        }
    }
    else if ((0, std_1.isTOCArticle)(el)) {
        const articleTitle = el.children.find(std.isArticleTitle);
        const articleCaption = el.children.find(std.isArticleCaption);
        lines.push(new line_1.ArticleLine({
            range: null,
            indentTexts,
            title: (0, _sentenceChildren_1.sentenceChildrenToString)(articleTitle?.children ?? []),
            midSpace: toCSTSettings_1.default.MARGIN,
            sentencesArray: articleCaption ? [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, articleCaption.children)])
            ] : [],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    else if ((0, std_1.isTOCSupplProvision)(el)) {
        const supplProvisionLabel = el.children.find(std.isSupplProvisionLabel);
        const articleRange = el.children.find(std.isArticleRange);
        lines.push(new line_1.SupplProvisionHeadLine({
            range: null,
            indentTexts,
            controls: [],
            title: (0, _sentenceChildren_1.sentenceChildrenToString)([
                ...(supplProvisionLabel?.children ?? []),
                ...(articleRange?.children ?? []),
            ]),
            titleRange: null,
            openParen: "",
            amendLawNum: "",
            closeParen: "",
            extractText: "",
            lineEndText: toCSTSettings_1.default.EOL,
        }));
        for (const child of el.children) {
            if (std.isSupplProvisionLabel(child) || std.isArticleRange(child)) {
                continue;
            }
            lines.push(...(0, exports.tocItemToLines)(child, childrenIndentTexts));
        }
        lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
    }
    else {
        (0, util_1.assertNever)(el);
    }
    return lines;
};
exports.tocItemToLines = tocItemToLines;
const tocToLines = (el, indentTexts) => {
    const lines = [];
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    const tocLabel = el.children.find(std.isTOCLabel);
    const title = (0, _sentenceChildren_1.sentenceChildrenToString)(tocLabel?.children ?? []);
    lines.push(new line_1.TOCHeadLine({
        range: null,
        indentTexts,
        // eslint-disable-next-line no-irregular-whitespace
        controls: ((indentTexts.length == 0) && /^目[ 　\t]*次/.test(title)) ? [] : [
            new inline_1.Control(":toc:", null, "", null)
        ],
        title: title,
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    for (const child of el.children) {
        if (std.isTOCLabel(child)) {
            continue;
        }
        lines.push(...(0, exports.tocItemToLines)(child, childrenIndentTexts));
    }
    return lines;
};
exports.tocToLines = tocToLines;
exports.$tocPreambleLabel = factory_1.default
    .withName("tocPreambleLabel")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.sentencesArray.length === 1) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .action(({ headLine }) => {
    const tocPreambleLabel = (0, std_1.newStdEL)("TOCPreambleLabel", {}, (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(headLine.line.sentencesArray), headLine.line.sentencesArrayRange);
    return {
        value: tocPreambleLabel,
        errors: [],
    };
}));
const $tocArticleGroupChildrenBlock = (0, util_2.makeIndentBlockWithCaptureRule)("$tableStructChildrenBlock", (factory_1.default
    .choice(c => c
    .or(() => exports.$tocArticleGroup))));
exports.$tocArticleGroup = factory_1.default
    .withName("tocArticleGroup")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === virtualLine_1.VirtualOnlyLineType.TAG) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .and(r => r
    .zeroOrOne(() => $tocArticleGroupChildrenBlock), "childrenBlock")
    .action(({ headLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    const inline = (0, util_3.mergeAdjacentTexts)(headLine.line.title);
    const lastItem = inline.length > 0 ? inline[inline.length - 1] : null;
    const [title, articleRangeSentenceChildren] = (lastItem instanceof controls_1.__Parentheses
        && lastItem.attr.type === "round") ? [inline.slice(0, -1), inline.slice(-1)] : [inline, []];
    const articleGroupTitleTag = std_1.articleGroupTitleTags[std_1.articleGroupTags.indexOf(headLine.line.mainTag)];
    const articleGroupTitle = (0, std_1.newStdEL)(articleGroupTitleTag, {}, title, (0, el_1.rangeOfELs)(title));
    children.push(articleGroupTitle);
    const articleRange = articleRangeSentenceChildren.length > 0 ? (0, std_1.newStdEL)("ArticleRange", {}, articleRangeSentenceChildren, (0, el_1.rangeOfELs)(articleRangeSentenceChildren)) : null;
    if (articleRange) {
        children.push(articleRange);
    }
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value));
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const tocArticleGroupTag = std_1.tocArticleGroupTags[std_1.articleGroupTags.indexOf(headLine.line.mainTag)];
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const tocArticleGroup = (0, std_1.newStdEL)(tocArticleGroupTag, {}, children, range);
    const num = (0, num_1.parseNamedNum)(articleGroupTitle.text());
    if (num)
        tocArticleGroup.attr.Num = num;
    return {
        value: tocArticleGroup,
        errors,
    };
}));
exports.$tocArticle = factory_1.default
    .withName("tocArticle")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.ART) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .action(({ headLine }) => {
    const articleTitle = (0, std_1.newStdEL)("ArticleTitle", {}, [headLine.line.title], headLine.line.titleRange);
    const articleCaptionChildren = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(headLine.line.sentencesArray);
    const articleCaption = headLine.line.sentencesArray.length > 0 ? (0, std_1.newStdEL)("ArticleCaption", {}, articleCaptionChildren, (0, el_1.rangeOfELs)(articleCaptionChildren)) : null;
    const tocArticleChildren = [
        articleTitle,
        ...(articleCaption ? [articleCaption] : []),
    ];
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(tocArticleChildren) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const tocArticle = (0, std_1.newStdEL)("TOCArticle", {}, tocArticleChildren, range);
    const num = (0, num_1.parseNamedNum)(headLine.line.title);
    if (num)
        tocArticle.attr.Num = num;
    return {
        value: tocArticle,
        errors: [],
    };
}));
const $tocSupplProvisionChildrenBlock = (0, util_2.makeIndentBlockWithCaptureRule)("$tocSupplProvisionChildrenBlock", (factory_1.default
    .choice(c => c
    .or(() => exports.$tocArticleGroup)
    .or(() => exports.$tocArticle))));
exports.$tocSupplProvision = factory_1.default
    .withName("tocSupplProvision")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === virtualLine_1.VirtualOnlyLineType.TSP) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .and(r => r
    .zeroOrOne(() => $tocSupplProvisionChildrenBlock), "childrenBlock")
    .action(({ headLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    const amendLawNumParentheses = new controls_1.__Parentheses({
        start: headLine.line.openParen,
        content: [new controls_1.__Text(headLine.line.amendLawNum, headLine.line.amendLawNumRange)],
        end: headLine.line.closeParen,
        type: "round",
        range: ((headLine.line.openParenRange && headLine.line.amendLawNumRange && headLine.line.closeParenRange)
            ? {
                start: headLine.line.openParenRange,
                content: headLine.line.amendLawNumRange,
                end: headLine.line.closeParenRange,
            }
            : null),
        depth: 0,
    });
    const inline = (0, util_3.mergeAdjacentTexts)([
        new controls_1.__Text(headLine.line.title, headLine.line.titleRange),
        ...((amendLawNumParentheses.text() === "")
            ? []
            : [amendLawNumParentheses]),
        new controls_1.__Text(headLine.line.extractText, headLine.line.extractTextRange),
    ]);
    const lastItem = inline.length > 0 ? inline[inline.length - 1] : null;
    const [title, articleRangeSentenceChildren] = (lastItem instanceof controls_1.__Parentheses
        && lastItem.attr.type === "round") ? [inline.slice(0, -1), inline.slice(-1)] : [inline, []];
    const supplProvisionLabel = (0, std_1.newStdEL)("SupplProvisionLabel", {}, title, (0, el_1.rangeOfELs)(title));
    children.push(supplProvisionLabel);
    const articleRange = articleRangeSentenceChildren.length > 0 ? (0, std_1.newStdEL)("ArticleRange", {}, articleRangeSentenceChildren, (0, el_1.rangeOfELs)(articleRangeSentenceChildren)) : null;
    if (articleRange) {
        children.push(articleRange);
    }
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value));
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const tocSupplProvision = (0, std_1.newStdEL)("TOCSupplProvision", {}, children, range);
    return {
        value: tocSupplProvision,
        errors,
    };
}));
const $tocChildrenBlock = (0, util_2.makeIndentBlockWithCaptureRule)("$tocChildrenBlock", (factory_1.default
    .choice(c => c
    .or(() => exports.$tocPreambleLabel)
    .or(() => exports.$tocArticleGroup)
    .or(() => exports.$tocArticle)
    .or(() => exports.$tocSupplProvision))));
/**
 * The parser rule for {@link std.TOC}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$toc.spec.ts) for examples.
 */
exports.$toc = factory_1.default
    .withName("toc")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.TOC) {
        return item;
    }
    else {
        return null;
    }
}), "headLine")
    .and(r => r
    .zeroOrOne(() => $tocChildrenBlock), "childrenBlock")
    .action(({ headLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    if (headLine.line.title.length > 0) {
        const tocLabel = (0, std_1.newStdEL)("TOCLabel", {}, [headLine.line.title], headLine.line.titleRange);
        children.push(tocLabel);
    }
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value));
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const pos = headLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const toc = (0, std_1.newStdEL)("TOC", {}, children, range);
    return {
        value: toc,
        errors,
    };
}));
exports.default = exports.$toc;
//# sourceMappingURL=$toc.js.map